import { EquipmentCard, ShortPalletPopup, EquipmentQuantityPopup } from 'components';
import { TripContext } from 'contexts';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useEquipmentService, useParamService } from 'services';
import { EquipmentShortReason, EquipmentType, StopEquipment } from 'services/types';
import { EQUIPMENT_MAX_QUANTITY } from 'utils';
import './load-equipments.scss';

export const LoadEquipments = () => {

    const { getIntValue } = useParamService
    const { updateStopEquipments } = useEquipmentService()

    const [isPalletShortVisible, setIsPalletShortVisible] = useState<boolean>(false)
    const [isQuantityExceeded, setIsQuantityExceeded] = useState<boolean>(false)
    const [selectedPalletShortReasons, setSelectedPalletShortReasons] = useState<EquipmentShortReason>({} as EquipmentShortReason)
    const [reasonOtherValue, setReasonOtherValue] = useState<string>('')
    const stopId: number | undefined = getIntValue('stopId')

    const tripContext = useContext(TripContext)
    const stopEquipments = tripContext.stopEquipments.filter(se => se.stopId === stopId) ?? []
    const palletShortReasons = (tripContext.equipmentShortReasons.toArray() ?? [])
        .sort((a, b) => (a.isCommentRequired ? 1 : 0) - (b.isCommentRequired ? 1 : 0)) ?? []
    const equipmentTypes = (tripContext.equipmentTypes.toArray() ?? []).sort(
            (a, b) => {
                if (a.isDeliveredInEditable === b.isDeliveredInEditable) return 0;
                return a.isDeliveredInEditable ? -1 : 1;
            }
        );

    useEffect(() => {
        const updateStopEquipment = async () => {
            if (stopEquipments)
                updateStopEquipments(stopEquipments)
        }
        updateStopEquipment()
    }, [])

    const onQuantityOutAdjusted = (equipmentTypeId: number, quantity: number): void => {
        const stopEquipments = tripContext.stopEquipments.filter(se => se.stopId === stopId)
        let index: number = stopEquipments.findIndex(equipment => equipment.equipmentTypeId == equipmentTypeId)
        let newStopEquipments: StopEquipment[] = [...stopEquipments]
        newStopEquipments[index].quantityOut = quantity
        const equipmentType: EquipmentType = equipmentTypes.find(type => type.id == newStopEquipments[index].equipmentTypeId) ?? {} as EquipmentType

        if (equipmentType && equipmentType.isShortReasonRequired && newStopEquipments[index].quantityIn >= newStopEquipments[index].quantityOut!) {
            newStopEquipments[index].shortComment = null
            newStopEquipments[index].equipmentShortReasonId = null
        }

        if (equipmentType && newStopEquipments[index].quantityOut! > EQUIPMENT_MAX_QUANTITY) {
            setIsQuantityExceeded(true)
            return
        }

        updateStopEquipments(newStopEquipments)
    }

    const onQuantityInAdjusted = (equipmentTypeId: number, quantity: number): void => {
        const stopEquipments = tripContext.stopEquipments.filter(se => se.stopId === stopId)
        let index: number = stopEquipments.findIndex(equipment => equipment.equipmentTypeId == equipmentTypeId)
        let newStopEquipments: StopEquipment[] = [...stopEquipments]
        newStopEquipments[index].quantityIn = quantity
        const equipmentType: EquipmentType = equipmentTypes.find(type => type.id == newStopEquipments[index].equipmentTypeId) ?? {} as EquipmentType

        if (equipmentType && newStopEquipments[index].quantityIn! > EQUIPMENT_MAX_QUANTITY) {
            setIsQuantityExceeded(true)
            return
        }

        updateStopEquipments(newStopEquipments)
    }

    const handleRadioChecked = (reasonId: number): void => {
        let palletShortReason: EquipmentShortReason = palletShortReasons.find(reason => reason.id === reasonId) ?? {} as EquipmentShortReason
        setSelectedPalletShortReasons(palletShortReason)
    }

    const onClickPopUpOk = (): void => {
        let index: number = stopEquipments.findIndex(equipment => equipmentTypes.some(type => type.id === equipment.equipmentTypeId && type.isShortReasonRequired == true))
        let newStopEquipments: StopEquipment[] = [...stopEquipments]
        newStopEquipments[index].equipmentShortReasonId = selectedPalletShortReasons.id
        newStopEquipments[index].shortComment = selectedPalletShortReasons.isCommentRequired ? reasonOtherValue : null
        setIsPalletShortVisible(false)
        updateStopEquipments(newStopEquipments)
    }

    const onClickButton = (id: number): void => {
        let stopEquipment: StopEquipment = stopEquipments.find(equipment => equipment.id == id) ?? {} as StopEquipment
        const reasons: EquipmentShortReason = palletShortReasons.find(reason => stopEquipment.equipmentShortReasonId === reason.id) ?? {} as EquipmentShortReason
        setSelectedPalletShortReasons(reasons)
        setReasonOtherValue(stopEquipment.shortComment!)
        setIsPalletShortVisible(true)
    }

    return (
        <Fragment>
            <div style={{ paddingBottom: "30px" }}>
                {equipmentTypes.map(equipment =>
                    <EquipmentCard
                        key={equipment.id}
                        equipmentTypeId={equipment.id}
                        stopId={stopId}
                        onQuantityOutAdjusted={onQuantityOutAdjusted}
                        onClickButton={onClickButton}
                        onQuantityInAdjusted={onQuantityInAdjusted}
                    />
                )}
            </div>
            <ShortPalletPopup
                isVisible={isPalletShortVisible}
                shortPallets={palletShortReasons}
                selectedPalletShortReasons={selectedPalletShortReasons}
                otherValue={reasonOtherValue}
                onOtherValueChanged={value => setReasonOtherValue(value)}
                onClickOk={onClickPopUpOk}
                handleRadioChecked={reasonId => handleRadioChecked(reasonId)}
            ></ShortPalletPopup>
            <EquipmentQuantityPopup
                isVisible={isQuantityExceeded}
                onClickOk={() => setIsQuantityExceeded(false)}
            />
        </Fragment>
    )
};
